import {
  Button as HeadlessButton,
  ButtonProps as HeadlessButtonProps,
} from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

type ButtonProps = HeadlessButtonProps & {
  outline?: boolean;
  selected?: boolean;
};

export const Button = ({
  selected = false,
  outline,
  className,
  ...props
}: ButtonProps) => {
  return (
    <HeadlessButton
      className={twMerge(
        `gap-4 rounded-xl bg-white px-5 py-3 text-black transition duration-300 ease-out`,
        outline && 'border border-black',
        selected && `bg-black text-white`,
        className as string,
      )}
      {...props}
    />
  );
};
